import React from 'react';
import { homePageData, promoTextHeader } from '../assets/dummyData/homePage';
import { boxes, HpMapData } from '../assets/dummyData/HpBoxesData';
import { locations } from '../assets/dummyData/map';

import Header from '../components/Header/Header';
import HpAbout from '../components/HpAbout/HpAbout';
import HpBoxes from '../components/HpBoxes/HpBoxes';
import HpMap from '../components/Hpmap/HpMap';
import Helmet from '../components/Helmet';

const HomePage = () => {
  const lang = "en";

  return (
    <div id="page-hp" className="page">
        <Helmet
          title="Candy Store | Captain Candy"
          metaDesc="Our stores can be found in various cities in Europe. But beware! Not every shop with a wooden interior is a guarantee of Captain Candy quality. Always look only for the original Captain Candy stores, which are a safe bet. You can find a list of our stores on our website."
        />
        <Header promoText={promoTextHeader[lang]} />
        <HpAbout
          data={homePageData[lang]}
        />
        <HpBoxes
          boxes={boxes[lang]}
          title={boxes.title[lang]}
        />
        <div className="clearfix" />
        <HpMap data={HpMapData[lang]} locations={locations[lang]} />
    </div>
  )
}

export default HomePage;
